import * as React from "react";
import Modal from "../../misc/components/modal";
import Alert, { AlertCategoryEnum } from "../../misc/components/Alert";
import { Required } from "../../forms/validation/Required";
import { useWebPortalApiClient } from "../../misc/api/WebPortalTokenClient";
import { TextBox } from "../../forms/informedv2/TextBox";
import { VersionValidator } from "../../forms/validation/VersionValidator";
import { DeviceTypes } from "../../misc/api/apiTypes";
import { Form, useFormApi, useFormState } from "informed";
import { nameof } from "ts-simple-nameof";

export interface ExportSpirotracConfigurationProps {
    studyId: string;
    onClose: () => void;
}

export interface ExportSpirotracConfigurationFormModel {
    version: string;
}

export const ExportSpirotracConfigurationModalBody = ({ studyId, onClose }: ExportSpirotracConfigurationProps) => {
    const client = useWebPortalApiClient();

    const formApi = useFormApi<ExportSpirotracConfigurationFormModel>();
    const exportSP6Configurations = async () => {
        formApi.validate();
        const state = formApi.getState();
        if (state.invalid)
            return;
        const result = await client.client.deviceConfiguration({ studyId: studyId, deviceType: DeviceTypes.Spirotrac6, version: state.values.version });

        result.resource.filter(e => e.content != "remote").forEach(resource => {
            const resourceContent = atob(resource.text)
            const fileName = capitalizeFirstLetter(resource.type)  + '.xml'
            downloadFile(new Blob([resourceContent], { type: 'application/xml' }), fileName);
        });

        result.resource.filter(e => e.content == "remote").forEach(resource => {
            const content = JSON.stringify(resource, null, 4);
            const fileName = capitalizeFirstLetter(resource.type)  + '.json'
            downloadFile(new Blob([content], { type: 'application/json' }), fileName);
        });
        onClose();
    }

    const capitalizeFirstLetter = (val: string) =>
        val.charAt(0).toUpperCase() + val.slice(1);

    const downloadFile = (content, name) => {
        const url = window.URL.createObjectURL(content);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = name;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
    }

    return (
        <Modal show={true} header="Update Devices Package Version" closeModalHandler={onClose}>
            <div className="row">
                <div className="col-md-12">
                    <div className="panel-body">
                        <div className="form-group col-md-6 col-sm-6 col-xs-12">
                            <label htmlFor="version">Version</label>
                            <TextBox<string, ExportSpirotracConfigurationFormModel>
                                id={nameof<ExportSpirotracConfigurationFormModel>(f => f.version)}
                                key={nameof<ExportSpirotracConfigurationFormModel>(f => f.version)}
                                field={nameof<ExportSpirotracConfigurationFormModel>(f => f.version)}
                                validate={v => Required(v) ?? VersionValidator(v)}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button id="updateButton" className="btn btn-primary" type="submit" disabled={false} onClick={exportSP6Configurations}>
                    Export
                </button>&nbsp;
                <button id="returnToListButton" className="btn btn-primary btn-outline" onClick={onClose}>
                    Return to List
                </button>
            </div>
        </Modal>
    )
}

export const ExportSpirotracConfigurationModal = ({ studyId, onClose }: ExportSpirotracConfigurationProps) => {
    return (
        <Modal show={true} header="Export Spirotrac6 Configurations" closeModalHandler={onClose}>
            <Form<ExportSpirotracConfigurationFormModel>>
                <ExportSpirotracConfigurationModalBody onClose={onClose} studyId={studyId} />
            </Form>
        </Modal>
    )

}

